import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const FlatsTitle = ({ lastUpdate }) => {
  const localizedLastUpdate = moment(lastUpdate).locale(window.currentLanguage);
  const date = localizedLastUpdate.format('D MMMM');
  const time = localizedLastUpdate.format('H:mm');

  return (
    <div className="FlatsTitle">
      {lastUpdate && (
        <div className="UISubtitle">
          <div className="UISubtitle-content FlatsTitle-update">
            <FormattedMessage id="lastUpdate" values={{ date, time }} />
          </div>
        </div>
      )}
    </div>
  );
};

FlatsTitle.propTypes = {
  lastUpdate: PropTypes.string,
};

export default FlatsTitle;
